import useStyles from './styles';
import { useHeaderState } from '@/hooks/useHeaderState';
import { HeaderLeft } from '@/sections/Header/HeaderLeft/HeaderLeft';
import { HeaderRight } from '@/sections/Header/HeaderRight/HeaderRight';

interface HeaderProps {
  onSettingsClick?: () => void;
  hideBack?: boolean;
}

export const Header = ({ onSettingsClick, hideBack }: HeaderProps) => {
  const classes = useStyles();
  const {
    screen,
    isAuthorized,
    viewCrop,
    viewSize,
    showBackButton,
    showGenerationsButton,
    showViewControls,
    handleBack,
    handleGenerationsClick,
    handleCloseApp,
    handleLogin,
    handleCropToggle,
    handleSizeChange,
    getMobileTitle,
  } = useHeaderState();

  return (
    <header className={classes.header}>
      <HeaderLeft
        screen={screen}
        showBackButton={hideBack ? false : showBackButton}
        mobileTitle={getMobileTitle()}
        onBack={handleBack}
      />
      <HeaderRight
        isAuthorized={isAuthorized}
        showViewControls={showViewControls}
        showGenerationsButton={showGenerationsButton}
        viewCrop={viewCrop}
        viewSize={viewSize}
        onLogin={handleLogin}
        onCropToggle={handleCropToggle}
        onSizeChange={handleSizeChange}
        onGenerationsClick={handleGenerationsClick}
        onCloseApp={handleCloseApp}
        onSettingsClick={onSettingsClick}
      />
    </header>
  );
};

export default Header;
